<template>
  <div class="relative min-h-screen">
    <NavBar />
    <main class="min-h-[31.5vh]"><NuxtPage /></main>
    <AppFooter />
  </div>
</template>

<script lang="ts" setup>
import NavBar from "~/components/nav-bar.vue";
import AppFooter from "~/components/app-footer.vue";
</script>
